import React from "react";


const Ct = () => {

    return (
        <div className="component-box">
            <div className="inline-box">
                <img src="img/box-blue.png" alt="cpu" className="icon led-icon" />
                <span>周辺機器</span>
            </div>
            <div className="led-box row">
                <div className="col-md-7">
                    <div className="title-box"><span>3. CT/SPI</span></div>
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th colSpan={4}>&nbsp;</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>CT-0</td>
                                <td>ok</td>
                                <td>CT-4</td>
                                <td>ok</td>
                            </tr>
                            <tr>
                                <td>CT-1</td>
                                <td>ok</td>
                                <td>CT-5</td>
                                <td>ok</td>
                            </tr>
                            <tr>
                                <td>CT-2</td>
                                <td>ok</td>
                                <td>CT-6</td>
                                <td>ok</td>
                            </tr>
                            <tr>
                                <td>CT-3</td>
                                <td>ok</td>
                                <td>CT-7</td>
                                <td>ok</td>
                            </tr>

                        </tbody>
                    </table>



                </div>
                <div className="col-md-5 smart-ai">
                    <img src="img/smartai.png" className="smartai" />
                </div>

                <div className="col-md-12">
                    <div className="box-wrapper failed-wrapper">
                        <span>CT/SPIの接続を確認できません。</span>
                        <div className="two-button-box">
                            <button className="retry">リトライ</button>
                            <button className="skip">スキップ</button>
                        </div>
                    </div>
                </div>

            </div>


        </div>

    );
};

export default Ct;